import { Formik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { PageTitle } from '../../../../_metronic/layout/core'
import { CaptableManagementBreadCrumbs } from '../core/_constants'
import TextInput from '../../widgets/components/Input/TextInput'
import { SelectInput } from '../../widgets/components/Input/SelectInput'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'
import { DataTableServerSideFinancialScenario } from '../components/DataTableServerSideFinancialScenario'
import Info from '../../../../media/shared-access/ic-info-yellow.svg'
import { useThemeMode } from '../../../../_metronic/partials'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { getConvertibleSecurityClasses } from '../../stakeholders/stakeholders-and-investors/core/_requests'
import { useAuth } from '../../auth'
import { useCurrency } from '../../../hooks/useCurrency'
import {
  AccuralPeriod,
  CompoundingMethod,
  valuationCapOptions,
} from '../../stakeholders/stakeholders-and-investors/core/_constants'
import ShareholderSearchTextInput from '../components/shareholder-search-text-input'
import { useFetchShareholders } from '../../../hooks/useFetchShareholders'
import {
  createScenario,
  createShareholderInvestment,
  getAllShareholderInvestments,
  getScenario,
  updateScenario,
} from '../core/_requests'
import { useNavigate, useParams } from 'react-router-dom'
import brandingConfig from '../../../../config/brandingConfig'
import { NoDataPage } from '../../resources/components/NoDataPage'

interface FinancialScenario {
  id: string
  stakeholdername: string
  email: string
  type: string
  existingInvestment: string | number
  newInvestment: string | number
}

const CreateNewScenario = () => {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const [sidebar, setSidebar] = useState(1)
  const { companyId, companyCurrency } = useAuth()
  const { currencyOptions } = useCurrency()
  const [stakeholderName, setStakeholderName] = useState('')
  const [stakeholderId, setStakeholderId] = useState('')
  const [isShareholderLoading, setIsShareholderLoading] = useState<boolean>(false)
  const [isLoading, setLoading] = useState(false)
  const [convertibleSecurityData, setConvertibleSecurityData] = useState<any[]>()
  const [, setShareholderDetail] = useState<any>(null)
  const [, setImgName] = useState('')
  const [investment, setInvestment] = useState<number>()
  const [shareholderInvestments, setShareholderInvestments] = useState<FinancialScenario[]>([])
  const [shareholderNewInvestmentIds, setShareholderNewInvestmentIds] = useState<string[]>([])
  const formikRef = useRef<any>(null)
  const [scenario, setScenario] = useState<any>()
  const { scenarioId } = useParams()
  const navigate = useNavigate()
  const [totalInvestment, setTotalInvestment] = useState<number>()
  const [, setPricePerShare] = useState<number>()
  const [allFields, setAllFields] = useState<any>()
  const {
    fetchStakeholder,
    onClickFocusText,
    fieldClicked,
    openShareholderDropdown,
    dropdownDataLoading,
    setOpenShareholderDropdown,
    dropDownData,
    setNewEntryButtonClicked,
  } = useFetchShareholders(setShareholderDetail, setImgName)
  const [totalShareholderInvestment, setTotalShareholderInvestment] = useState<number>(0)

  const sidebarOptions = [
    { title: formatMessage({ id: 'Create Scenario' }) },
    ...(convertibleSecurityData && convertibleSecurityData.length > 0
      ? [{ title: formatMessage({ id: 'Convert Notes' }) }]
      : []),
    { title: formatMessage({ id: 'Add Investors' }) },
  ]

  const [selectedToggles, setSelectedToggles] = useState<string[]>([])
  const alllocalStorageFields = JSON.parse(localStorage.getItem('formFields') || '{}')
  const storedToggles = localStorage.getItem('selectedToggles')

  const handleSubmit = async (values: any) => {
    setLoading(true)
    const rawPayload = {
      scenarioName: values?.scenarioName,
      roundName: values?.roundName,
      currencyId: parseInt(values?.currencyId),
      preMoneyValuation: parseInt(values?.preMoneyValuation),
      newInvestment: parseInt(values?.newInvestment),
      exchangeRate: parseInt(values?.exchangeRate),
      pricePerShare: parseInt(values?.pricePerShare),
      entryDate: values?.entryDate,
      exitDate: values?.exitDate,
      convertibleClassIds: selectedToggles,
      shareholderNewInvestmentIds,
    }
    if (scenarioId) {
      try {
        const {
          data: { success },
        } = await updateScenario(companyId!, rawPayload, scenarioId)
        if (success) {
          navigate(`../scenarios/financial-details/${scenarioId}`)
        }
      } catch (err) {
        console.log(err, ' err')
      } finally {
        setLoading(false)
      }
    } else {
      try {
        const {
          data: { success },
        } = await createScenario(rawPayload, companyId!)
        if (success) {
          navigate(`../scenarios`)
        }
      } catch (err) {
        console.log(err, ' err')
      } finally {
        setLoading(false)
      }
    }
  }

  const handleToggle = (securityId: string) => {
    setSelectedToggles((prevSelected) => {
      if (prevSelected.includes(securityId)) {
        return prevSelected.filter((id) => id !== securityId)
      } else {
        return [...prevSelected, securityId]
      }
    })
  }

  const initialValues = {
    sidebar: scenarioId ? 1 : alllocalStorageFields ? 3 : 1,
    scenarioName: scenarioId
      ? scenario?.scenario?.scenarioName
      : alllocalStorageFields?.scenarioName || '',
    roundName: scenarioId ? scenario?.scenario?.roundName : alllocalStorageFields?.roundName || '',
    currencyId:
      currencyOptions.find((currencyId) => currencyId?.name?.split(' ')[0] === companyCurrency)
        ?.value ?? null,
    preMoneyValuation: scenarioId
      ? scenario?.scenario?.preMoneyValuation
      : alllocalStorageFields?.preMoneyValuation || 0,

    newInvestment: scenarioId
      ? scenario?.scenario?.newInvestment
      : alllocalStorageFields?.newInvestment || 0,

    pricePerShare: scenarioId
      ? scenario?.scenario?.pricePerShare
      : alllocalStorageFields?.pricePerShare || 0,

    exchangeRate: scenarioId
      ? scenario?.scenario?.exchangeRate
      : alllocalStorageFields?.exchangeRate || 0,

    entryDate: scenarioId
      ? scenario?.scenario?.entryDate?.split('T')[0]
      : alllocalStorageFields?.entryDate || '',

    exitDate: scenarioId
      ? scenario?.scenario?.exitDate?.split('T')[0]
      : alllocalStorageFields?.exitDate || '',
  }
  const userSchema = Yup.object().shape({
    scenarioName: Yup.string()
      .min(2, 'Scenario name must be at least 2 characters')
      .max(50, 'Scenario name must be 50 characters or less')
      .nullable()
      .required('Scenario name is required'),

    roundName: Yup.string()
      .min(2, 'Round name must be at least 2 characters')
      .max(50, 'Round name must be 50 characters or less')
      .nullable()
      .required('Round name is required'),

    currencyId: Yup.string().nullable(),

    preMoneyValuation: Yup.number()
      .min(0, 'Pre-money valuation must be 0 or greater')
      .required('Pre-money valuation is required'),

    newInvestment: Yup.number()
      .min(0, 'New investment must be 0 or greater')
      .required('New investment is required'),

    pricePerShare: Yup.number()
      .min(0, 'Price per share must be 0 or greater')
      .required('Price per share is required'),

    exchangeRate: Yup.number()
      .min(0, 'Exchange rate must be 0 or greater')
      .required('Exchange rate is required'),

    entryDate: Yup.date().nullable().required('Entry date is required'),

    exitDate: Yup.date().nullable().required('Exit date is required'),
  })
  const fetchConvertibleSecurityClasses = async () => {
    if (!companyId) return
    try {
      const response = await getConvertibleSecurityClasses(companyId, 1, 10)
      if (response.data.success) {
        setConvertibleSecurityData(response.data.data?.convertibleSecurityClasses)
      } else {
        // toast.error(response.data.errors[0])
      }
    } catch (error) {
      console.error('Error fetching convertible security classes:', error)
    } finally {
    }
  }

  useEffect(() => {
    fetchConvertibleSecurityClasses()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // const validateInvestment = (
  //   investment: number,
  //   pricePerShare: number,
  //   totalInvestment: number,
  //   shareholdersInvestmentData: any
  // ) => {
  //   if (!investment || investment <= 0) {
  //     return {valid: false, message: 'Investment amount must be greater than 0.'}
  //   }

  //   if (investment % pricePerShare !== 0) {
  //     return {valid: false, message: `Investment must be a multiple of ${pricePerShare}.`}
  //   }
  //   const alreadyInvested = shareholdersInvestmentData.reduce(
  //     (sum: number, item: any) => sum + item.investment,
  //     0
  //   )
  //   const remainingInvestment = totalInvestment - alreadyInvested
  //   if (investment > remainingInvestment) {
  //     return {
  //       valid: false,
  //       message: `Investment exceeds the remaining available funds. Only ${remainingInvestment} is available.`,
  //     }
  //   }

  //   return {valid: true}
  // }

  const mapInvestmentToFinancialScenario = (investment: any): FinancialScenario => ({
    id: investment.shareholderNewInvestmentId,
    stakeholdername: investment.name,
    email: investment.email,
    type: investment.type,
    existingInvestment: investment.totalExistingInvestment || 0,
    newInvestment: investment.investment || 0,
  })
  const getAllInvestments = async () => {
    try {
      const payload: any = {
        investmentIds: shareholderNewInvestmentIds,
      }
      const {
        data: { data, success },
      } = await getAllShareholderInvestments(companyId!, payload)
      if (success) {
        const mappedInvestments: FinancialScenario[] = Array.isArray(data?.investorDTO)
          ? data.investorDTO.flatMap((group: any) =>
            Array.isArray(group)
              ? group.map((investment: any) => mapInvestmentToFinancialScenario(investment))
              : [mapInvestmentToFinancialScenario(group)]
          )
          : []

        setShareholderInvestments((prevInvestments: FinancialScenario[]) => {
          const combinedInvestments = [...prevInvestments, ...mappedInvestments]
          const uniqueInvestments = Array.from(
            new Map(combinedInvestments.map((item) => [item.id, item])).values()
          )
          const total = uniqueInvestments.reduce((sum, investment) => {
            return sum + (Number(investment.newInvestment) || 0)
          }, 0)

          setTotalShareholderInvestment(total)
          return uniqueInvestments
        })
      }
    } catch (err) { }
  }

  const createShareholdersInvestments = async () => {
    setIsShareholderLoading(true)
    // const validationResponse = validateInvestment(
    //   investment!,
    //   pricePerShare!,
    //   totalInvestment!,
    //   shareholderInvestments
    // )
    // if (!validationResponse.valid) {
    //   toast.error(validationResponse?.message)
    //   setIsShareholderLoading(false)
    //   return
    // }

    if (!companyId) return
    try {
      const {
        data: { data, success, errors },
      } = await createShareholderInvestment(
        { shareholderId: stakeholderId, investment: investment || 0 },
        companyId
      )
      if (success) {
        const { shareholderNewInvestmentId } = data?.newInvestment
        // const updatedInvestments: any = [
        //   ...shareholderInvestments,
        //   {
        //     shareholderId,
        //     shareholderNewInvestmentId,
        //     investment,
        //   },
        // ]

        // const newInvestmentIds = updatedInvestments.map(
        //   (item: any) => item.shareholderNewInvestmentId
        // )
        // setShareholderNewInvestmentIds(newInvestmentIds)

        // setShareholderInvestments(updatedInvestments)
        setShareholderNewInvestmentIds((prevIds: string[]) => [
          ...prevIds,
          shareholderNewInvestmentId,
        ])
        // getAllInvestments([shareholderNewInvestmentId])
      } else {
        toast.error(errors[0])
      }
    } catch (error) {
      console.error('Error fetching convertible security classes:', error)
    } finally {
      setIsShareholderLoading(false)
    }
  }

  const getSenarios = async () => {
    if (!companyId) return
    try {
      const {
        data: { data, success },
      } = await getScenario(companyId, scenarioId!)
      if (success) {
        setScenario(data)
        setSelectedToggles(
          data.scenario.scenario_convertibleClassMaps.map((item: any) => item.convertibleClassId)
        )
        setShareholderInvestments(
          data.scenario.investorDTO.map((item: any) => ({
            id: item.shareholderNewInvestmentId,
            stakeholdername: item.name || 'N/A',
            email: item.email,
            type: item.type,
            existingInvestment: item.totalExistingInvestment.toString() || '0',
            newInvestment: item.investment.toString() || '0',
          }))
        )
        const ids = data.investorDTO.map((item: any) => item.shareholderNewInvestmentId)
        setShareholderNewInvestmentIds(ids)
      }
    } catch (error) {
      console.error('Error fetching convertible security classes:', error)
    } finally {
    }
  }

  useEffect(() => {
    if (scenarioId) {
      getSenarios()
    }
  }, [scenarioId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!scenarioId) {
      if (storedToggles) {
        setSelectedToggles(JSON.parse(storedToggles))
      }
    }
  }, [storedToggles]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (shareholderNewInvestmentIds.length > 0) {
      getAllInvestments()
    }
  }, [shareholderNewInvestmentIds]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PageTitle
        breadcrumbs={CaptableManagementBreadCrumbs}
        description={formatMessage({ id: 'Scenarios' })}
      >
        {formatMessage({ id: 'Cap Table Management' })}
      </PageTitle>
      <div className='d-flex flex-md-row flex-column px-6'>
        <div className='sidebar-investor-db col-md-1 d-none d-md-flex'>
          {sidebarOptions.map((sideTabs, index) => (
            <ul
              key={index}
              className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer'
            >
              <li
                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${(
                  index === 1 && convertibleSecurityData && convertibleSecurityData.length === 0
                    ? sidebar === index + 2
                    : sidebar === index + 1
                )
                  ? 'border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                  : ''
                  }`}
                onClick={() => {
                  if (
                    index === 1 &&
                    convertibleSecurityData &&
                    convertibleSecurityData.length === 0
                  ) {
                    setSidebar(3)
                    formikRef.current.setFieldValue('sidebar', 3)
                  } else {
                    setSidebar(index + 1)
                    formikRef.current.setFieldValue('sidebar', index + 1)
                  }
                }}
              >
                {formatMessage({ id: sideTabs.title })}
              </li>
            </ul>
          ))}
        </div>
        <div className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none' style={{ width: '100%' }}>
          <div
            className='d-md-none d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs, index) => (
              <ul
                className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent mt-0 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                style={{ display: 'flex', flexWrap: 'nowrap' }}
                key={index}
              >
                <li
                  className={
                    `nav-link text-active-primary py-3 ps-3 d-flex align-items-center` +
                    (sidebar === index + 1
                      ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                      : '')
                  }
                  onClick={() => {
                    if (
                      index === 1 &&
                      convertibleSecurityData &&
                      convertibleSecurityData.length === 0
                    ) {
                      setSidebar(3)
                    } else {
                      setSidebar(index + 1)
                    }
                  }}
                >
                  {formatMessage({ id: sideTabs.title })}
                </li>
              </ul>
            ))}
          </div>
        </div>
        <div className='rounded-2 bg-white p-8 w-100'>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={userSchema}
            innerRef={formikRef}
            onSubmit={handleSubmit}
            validateOnMount
          >
            {(formik) => {
              setAllFields(formik.values)
              setTotalInvestment(formik.values.newInvestment)
              setPricePerShare(formik.values.pricePerShare)
              return (
                <Form>
                  {sidebar === 1 && (
                    <div>
                      <div className=''>
                        <InfoCard2
                          className='w-100'
                          title={formatMessage({
                            id: 'Learn to Analyze Ownership Scenarios in Your Cap Table',
                          })}
                          desc={formatMessage({
                            id: `Use ${brandingConfig.brandName}’s Scenario Analysis tool to run advanced waterfall analyses and project future ownership scenarios with ease.`,
                          })}
                          slug={brandingConfig.helpLinks.captableManagementCreateScenario}
                        />
                      </div>
                      <div className='w-100 mt-10'>
                        <div className='row'>
                          <div className='col-md-6 col-12'>
                            <TextInput
                              fieldType='text'
                              label={formatMessage({ id: 'Scenario Name' })}
                              fieldName='scenarioName'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Enter Scenario Name' })}
                              toolTipText={formatMessage({
                                id: 'Add email address of the founder you are adding here.',
                              })}
                              isStarRequired
                              onBlur={formik.handleBlur}
                            />
                          </div>
                          <div className='col-md-6 col-12'>
                            <TextInput
                              fieldType='text'
                              label={formatMessage({ id: 'Round Name' })}
                              fieldName='roundName'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Enter Round Name' })}
                              toolTipText={formatMessage({
                                id: 'Add email address of the founder you are adding here.',
                              })}
                            />
                          </div>
                          <div className='col-md-6 col-12'>
                            <SelectInput
                              label={formatMessage({ id: 'Currency' })}
                              fieldName='currencyId'
                              placeholder={formatMessage({
                                id: 'Select Currency',
                              })}
                              formik={formik}
                              toolTipText={formatMessage({
                                id: 'Select a govt. issued ID type for the founder that your adding.',
                              })}
                              options={currencyOptions}
                              isStarRequired
                              disabled={true}
                            />
                          </div>
                          <div className='col-md-6 col-12'>
                            <TextInput
                              fieldType='number'
                              label={formatMessage({ id: 'Pre Money Valuation' })}
                              fieldName='preMoneyValuation'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Enter Pre Money Valuation' })}
                              toolTipText={formatMessage({
                                id: 'Add email address of the founder you are adding here.',
                              })}
                            />
                          </div>
                          <div className='col-md-6 col-12'>
                            <TextInput
                              fieldType='number'
                              label={formatMessage({ id: 'New Investment' })}
                              fieldName='newInvestment'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Enter New Investment' })}
                              toolTipText={formatMessage({
                                id: 'Add email address of the founder you are adding here.',
                              })}
                            />
                          </div>
                          <div className='col-md-6 col-12'>
                            <TextInput
                              fieldType='number'
                              label={formatMessage({ id: 'Price Per Share' })}
                              fieldName='pricePerShare'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Enter Price Per Share' })}
                              toolTipText={formatMessage({
                                id: 'Add email address of the founder you are adding here.',
                              })}
                            />
                          </div>
                          <div className='col-md-6 col-12'>
                            <TextInput
                              fieldType='text'
                              label={formatMessage({ id: 'Exchange Rate' })}
                              fieldName='exchangeRate'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Enter Exchange Rate' })}
                              toolTipText={formatMessage({
                                id: 'Add email address of the founder you are adding here.',
                              })}
                            />
                          </div>
                          <div className='col-md-6 col-12'>
                            <TextInput
                              fieldType='date'
                              label={formatMessage({ id: 'Entry Date' })}
                              fieldName='entryDate'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Select Entry Date' })}
                              toolTipText={formatMessage({
                                id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.DOB',
                              })}
                              isStarRequired={true}
                              isDateField={true}
                            />
                          </div>
                          <div className='col-md-6 col-12'>
                            <TextInput
                              fieldType='date'
                              label={formatMessage({ id: 'Exit Date' })}
                              fieldName='exitDate'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Select Exit Date' })}
                              toolTipText={formatMessage({
                                id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.DOB',
                              })}
                              isStarRequired={true}
                              isDateField={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className='d-flex flex-md-row flex-column w-md-auto justify-content-end px-md-6 px-0 gap-3'>
                          <div className='w-100 w-md-auto order-2 order-md-1 '>
                            <button type='button' className='btn bg-light text-muted custom-button-property w-100'>
                              {formatMessage({ id: 'Cancel' })}
                            </button>
                          </div>
                          <div className='w-100 w-md-auto order-1 order-md-2 mb-2 mb-md-auto'>
                            <button
                              type='button'
                              onClick={() => {
                                if (
                                  sidebar === 1 &&
                                  convertibleSecurityData &&
                                  convertibleSecurityData.length === 0
                                ) {
                                  setSidebar(3)
                                  if (formikRef.current)
                                    formikRef.current.setFieldValue('sidebar', 3)
                                } else {
                                  setSidebar(sidebar + 1)
                                  if (formikRef.current)
                                    formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                }
                              }}
                              className='btn bg-primary custom-button-property text-white w-100'
                              disabled={scenarioId! ? false : !formik.isValid || !formik.dirty}
                            >
                              {formatMessage({ id: 'Next' })}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {sidebar === 2 && (
                    <div>
                      <div className=''>
                        <InfoCard2
                          className='w-100'
                          title={formatMessage({
                            id: 'Learn to Analyze Ownership Scenarios in Your Cap Table',
                          })}
                          desc={formatMessage({
                            id: 'Use Foundercrate’s Scenario Analysis tool to run advanced waterfall analyses and project future ownership scenarios with ease.',
                          })}
                          slug={brandingConfig.helpLinks.captableManagementCreateScenario}
                        />
                      </div>
                      <div className='w-100 mt-10'>
                        <div className='accordion mb-7' id='accordionExample'>
                          {convertibleSecurityData &&
                            convertibleSecurityData.map((security, index) => (
                              <div className='accordion-item border mb-4'>
                                <h2 className='accordion-header'>
                                  <div className='d-flex justify-content-center align-items-center'>
                                    <button
                                      className='accordion-button d-flex justify-content-between py-4'
                                      type='button'
                                      data-bs-toggle='collapse'
                                      data-bs-target={`#collapse-${security?.convertibleClassId}`}
                                      aria-expanded='true'
                                      aria-controls={`collapse-${security?.convertibleClassId}`}
                                    >
                                      <span className='badge text-bg-success text-light p-3'>
                                        {formatMessage({ id: 'Conv Sept 2024' })}
                                      </span>
                                      <span className='me-10'>
                                        <div className='d-flex align-items-center'>
                                          <label className='toggle'>
                                            <input
                                              className='toggle__input'
                                              name='toggle-input'
                                              type='checkbox'
                                              checked={selectedToggles.includes(
                                                security?.convertibleClassId
                                              )}
                                              onChange={() =>
                                                handleToggle(security?.convertibleClassId)
                                              }
                                            />
                                            <div className='toggle__fill'></div>
                                          </label>
                                        </div>
                                      </span>
                                    </button>
                                  </div>
                                </h2>
                                <div
                                  id={`collapse-${security?.convertibleClassId}`}
                                  className='accordion-collapse collapse'
                                  data-bs-parent='#accordionExample'
                                >
                                  <div className='accordion-body row py-7'>
                                    <div className='col-md-6 col-12'>
                                      <div className='mb-7'>
                                        <label
                                          htmlFor='conversion-date'
                                          className='form-label font-size-13'
                                        >
                                          {formatMessage({ id: 'Convertion Date' })}
                                          <ToolTipUIForModal
                                            tooltipText={formatMessage({
                                              id: 'Specify the conversion date for this round of conversion.',
                                            })}
                                          />
                                        </label>
                                        <input
                                          type='date'
                                          id='conversion-date'
                                          className='form-control'
                                          placeholder={formatMessage({ id: 'Select Date' })}
                                          value={security?.dateOfIssue}
                                          readOnly
                                          title={formatMessage({
                                            id: 'Specify the conversion date for this round of conversion.',
                                          })}
                                        />
                                      </div>
                                    </div>

                                    <div className='col-md-6 col-12'>
                                      <SelectInput
                                        label={formatMessage({ id: 'Currency' })}
                                        fieldName='currencyId'
                                        placeholder={formatMessage({
                                          id: 'Select Currency',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.CLASS_CURRENCY',
                                        })}
                                        options={currencyOptions}
                                        isTooltipForModal={true}
                                        disabled={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <div className='select-input mb-7'>
                                        <label className='select-input__label form-label font-size-13'>
                                          {formatMessage({ id: 'Valuation Cap Type' })}
                                          <ToolTipUIForModal tooltipText='Select the valuation cap type for this conversion round.' />
                                        </label>
                                        <select
                                          id='valuation-cap-type'
                                          className='form-control'
                                          value={security?.valuationCapType}
                                          disabled
                                          title={formatMessage({
                                            id: 'Enter the valuation cap price for this conversion round.',
                                          })}
                                        >
                                          {valuationCapOptions.map((option) => (
                                            <option key={option.id} value={option.value}>
                                              {option.label}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <div className='mb-7'>
                                        <label className='select-input__label form-label font-size-13'>
                                          {formatMessage({ id: 'Valuation Cap' })}
                                          <ToolTipUIForModal tooltipText='Enter the valuation cap price for this conversion round.' />
                                        </label>
                                        <input
                                          type='text'
                                          id='valuation-cap'
                                          className='form-control'
                                          value={security?.valuationCap || ''}
                                          disabled
                                          readOnly
                                          title={formatMessage({
                                            id: 'Enter the valuation cap price for this conversion round.',
                                          })}
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <div className='select-input mb-7'>
                                        <label className='select-input__label form-label font-size-13'>
                                          {formatMessage({ id: 'Valuation Floor Type' })}
                                          <ToolTipUIForModal tooltipText='Select the valuation floor type for this conversion.' />
                                        </label>
                                        <select
                                          id='valuation-floor-type'
                                          className='form-control'
                                          value={security?.valuationFloorType}
                                          disabled
                                          title={formatMessage({
                                            id: 'Enter the valuation floor price for this conversion round.',
                                          })}
                                        >
                                          {valuationCapOptions.map((option) => (
                                            <option key={option.id} value={option.value}>
                                              {option.label}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <div className='mb-7'>
                                        <label className='select-input__label form-label font-size-13'>
                                          {formatMessage({ id: 'Valuation Floor' })}
                                          <ToolTipUIForModal tooltipText='Enter the valuation floor price for this conversion.' />
                                        </label>
                                        <input
                                          type='text'
                                          id='valuation-floor'
                                          className='form-control'
                                          value={security?.valuationFloor || ''}
                                          disabled
                                          readOnly
                                          title={formatMessage({
                                            id: 'Enter the valuation floor price for this conversion round.',
                                          })}
                                        />
                                      </div>
                                    </div>

                                    <div className='d-md-flex flex-md-column my-4 mb-8 px-3 px-md-3'>
                                      <div className='d-flex form-label  text-dark font-size-13'>
                                        {formatMessage({ id: 'Include Interest? (From Issue Date)' })}{' '}
                                        <ToolTipUIForModal
                                          tooltipText={formatMessage({
                                            id: 'Specify if you want to include the interest from the issuance date.',
                                          })}
                                        />
                                      </div>
                                      <div className='d-flex align-items-center gap-4'>
                                        <div className='d-flex align-items-center gap-1'>
                                          <input
                                            type='radio'
                                            id={`interest-yes-${index}`}
                                            name={`isInterest-${index}`}
                                            value='yes'
                                            checked={security?.convertibleInterestRate === 'yes'}
                                            width={48}
                                            height={48}
                                          />
                                          <label htmlFor='interest-yes'>
                                            {formatMessage({ id: 'Yes' })}
                                          </label>
                                        </div>
                                        <div className='d-flex align-items-center gap-1'>
                                          <input
                                            type='radio'
                                            id={`interest-no-${index}`}
                                            name={`isInterest-${index}`}
                                            value='no'
                                            checked={security?.convertibleInterestRate === 'no'}
                                            width={48}
                                            height={48}
                                          />
                                          <label htmlFor='interest-no'>
                                            {formatMessage({ id: 'No' })}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <div className='form-group mb-7'>
                                        <label
                                          htmlFor='annualInterest'
                                          className='form-label font-size-13'
                                        >
                                          {formatMessage({ id: 'Annual Interest Rate(%)' })}
                                          <ToolTipUIForModal
                                            tooltipText={formatMessage({
                                              id: 'Specify the annual rate of interest for this conversion round.Specify the annual rate of interest for this conversion round.',
                                            })}
                                          />
                                          {/* <span className='required'></span> */}
                                        </label>
                                        <input
                                          type='number'
                                          id='annualInterest'
                                          className='form-control'
                                          value={security?.rate || 1}
                                          placeholder={formatMessage({
                                            id: 'Enter Annual Interest Rate(%)',
                                          })}
                                          title={formatMessage({
                                            id: 'Specify the annual rate of interest for this conversion round.',
                                          })}
                                        />
                                        <small className='form-text text-muted'>
                                          {formatMessage({
                                            id: 'Specify the annual rate of interest for this conversion round.',
                                          })}
                                        </small>
                                      </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <div className='mb-7'>
                                        <label
                                          htmlFor='accuralBasis'
                                          className='form-label font-size-13'
                                        >
                                          {formatMessage({ id: 'Accrual Basis' })}
                                          <ToolTipUIForModal
                                            tooltipText={formatMessage({
                                              id: 'Select the accrual basis for this conversion round.',
                                            })}
                                          />
                                        </label>
                                        <select
                                          id='accuralBasis'
                                          value={security?.accrualPeriod} // This will hold the selected value
                                          className='form-control'
                                          placeholder={formatMessage({ id: 'Select Accrual Basis' })}
                                        >
                                          <option value=''>
                                            {formatMessage({ id: 'Select Accrual Basis' })}
                                          </option>
                                          {Object.values(AccuralPeriod).map((option) => (
                                            <option key={option} value={option}>
                                              {formatMessage({ id: option })}{' '}
                                            </option>
                                          ))}
                                        </select>
                                        <small className='form-text text-muted'>
                                          {formatMessage({
                                            id: 'Select the accrual basis for this conversion round.',
                                          })}
                                        </small>
                                      </div>
                                    </div>

                                    <div className='col-md-6 col-12'>
                                      <div className='mb-7'>
                                        <label
                                          htmlFor='compoundingMethod'
                                          className='form-label font-size-13'
                                        >
                                          {formatMessage({ id: 'Compounding Method' })}
                                          <ToolTipUIForModal
                                            tooltipText={formatMessage({
                                              id: 'Select a compounding method for interest calculation for this conversion.',
                                            })}
                                          />
                                        </label>
                                        <select
                                          id='compoundingMethod'
                                          value={security?.compoundingMethod}
                                          className='form-control'
                                        >
                                          <option value=''>
                                            {formatMessage({ id: 'Select Compounding Method' })}
                                          </option>
                                          {Object.values(CompoundingMethod).map((option) => (
                                            <option key={option} value={option}>
                                              {formatMessage({ id: option })}
                                            </option>
                                          ))}
                                        </select>
                                        <small className='form-text text-muted'>
                                          {formatMessage({
                                            id: 'Select the compounding method for this conversion round.',
                                          })}
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div>
                        <div className='d-flex flex-md-row flex-column w-md-auto justify-content-end px-md-6 px-0 gap-3'>
                          <div className='w-100 w-md-auto order-2 order-md-1 '>
                            <button type='button' className='btn bg-light text-muted custom-button-property w-100'>
                              {formatMessage({ id: 'Cancel' })}
                            </button>
                          </div>
                          <div className='w-100 w-md-auto order-1 order-md-2 mb-2 mb-md-auto'>
                            <button
                              type='button'
                              onClick={() => {
                                setSidebar(sidebar + 1)
                                if (formikRef.current)
                                  formikRef.current.setFieldValue('sidebar', sidebar + 1)
                              }}
                              className='btn bg-primary text-white custom-button-property w-100'
                            >
                              {formatMessage({ id: 'Next' })}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {sidebar === 3 && (
                    <div className='w-100'>
                      <InfoCard2
                        title={formatMessage({
                          id: 'Learn to Analyze Ownership Scenarios in Your Cap Table ',
                        })}
                        desc={formatMessage({
                          id: 'Use Foundercrate’s Scenario Analysis tool to run advanced waterfall analyses and project future ownership scenarios with ease.',
                        })}
                        slug={brandingConfig.helpLinks.captableManagementCreateScenario}
                        className='w-100 mb-0'
                      />
                      <div className=''>
                        <div className='my-8'>
                          <div
                            className='p-2 rounded d-flex align-items-center gap-2'
                            style={
                              mode === 'dark'
                                ? { background: '#6C4F2C', border: '2px dashed #FFC700' }
                                : { background: '#FFF8DD', border: '2px dashed #FFC700' }
                            }
                          >
                            <img src={Info} alt='Info' />
                            <p className='m-0 text-dark font-size-12'>
                              {`Unallocated Amount: ${(totalInvestment ?? 0) - totalShareholderInvestment
                                }`}
                            </p>
                          </div>
                        </div>
                        <div className='w-100 mt-10'>
                          <div className='d-md-flex align-items-start gap-4'>
                            <div className='w-100'>
                              <ShareholderSearchTextInput
                                label={formatMessage({ id: 'Stakeholder Name' })}
                                toolTipText={formatMessage({
                                  id: 'Add name of the shareholder here.',
                                })}
                                dropdownData={dropDownData}
                                dropdownDataLoading={dropdownDataLoading}
                                openShareholderDropdown={openShareholderDropdown}
                                onSelect={(id: string) => {
                                  setOpenShareholderDropdown(false)
                                  fetchStakeholder(id)
                                }}
                                onNewEntryButtonClick={() => {
                                  setOpenShareholderDropdown(false)
                                  setNewEntryButtonClicked(true)
                                }}
                                fieldClicked={fieldClicked}
                                setOpenShareholderDropdown={setOpenShareholderDropdown}
                                placeholder={formatMessage({ id: 'Enter First Name' })}
                                ariaLabel='shareholderName'
                                onFocus={(e: any) => {
                                  onClickFocusText(e)
                                }}
                                value={stakeholderName}
                                setStakeholderName={setStakeholderName}
                                setStakeholderId={setStakeholderId}
                                allFields={allFields}
                                selectedToggles={selectedToggles}
                              />
                            </div>
                            <div className='w-100'>
                              <div className='input-container'>
                                {/* Label */}
                                <label htmlFor='investment-input' className='input-label mb-2'>
                                  {formatMessage({ id: 'Investment' })}
                                  <span className='required-star'>*</span>
                                  <ToolTipUIForModal
                                    tooltipText={formatMessage({
                                      id: 'Enter investment amount',
                                    })}
                                  />
                                </label>

                                {/* Input Field */}
                                <input
                                  id='investment-input'
                                  type='number'
                                  value={investment}
                                  onChange={(e: any) => {
                                    setInvestment(e.target.value)
                                  }}
                                  placeholder={formatMessage({ id: 'Enter Investment Amount' })}
                                  className='form-control h-40px font-size-12 mb-8'
                                />
                              </div>
                            </div>
                            <div className='d-flex justify-content-end w-100 w-md-50 mt-4 mt-md-8 height-40'>
                              <button
                                type='button'
                                className='btn bg-primary text-white custom-button-property w-100 py-3'
                                onClick={createShareholdersInvestments}
                              >
                                {isShareholderLoading
                                  ? formatMessage({ id: 'Please wait...' })
                                  : formatMessage({ id: 'Add' })}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {scenarioId && scenario && shareholderInvestments && (
                        <DataTableServerSideFinancialScenario
                          shareholderInvestments={shareholderInvestments}
                          setShareholderInvestments={setShareholderInvestments}
                        />
                      )} */}
                      {shareholderInvestments && shareholderInvestments.length > 0 ? (
                        <DataTableServerSideFinancialScenario
                          shareholderInvestments={shareholderInvestments}
                          setShareholderInvestments={setShareholderInvestments}
                        />
                      ) : (
                        <NoDataPage />
                      )}

                      <div>
                        <div className='d-flex flex-md-row flex-column w-md-auto justify-content-end px-md-6 px-0 gap-3'>
                          <div className='w-100 w-md-auto order-2 order-md-1 '>
                            <button type='button' className='btn bg-light text-muted custom-button-property w-100'>
                              {formatMessage({ id: 'Cancel' })}
                            </button>
                          </div>
                          <div className='w-100 w-md-auto order-1 order-md-2 mb-2 mb-md-auto'>
                            <button
                              type='button'
                              className='btn bg-primary text-white custom-button-property w-100'
                              disabled={
                                !formik.isValid || isLoading || shareholderInvestments.length === 0
                              }
                              onClick={formik.submitForm}
                            >
                              {isLoading ? (
                                <span className='indicator-label font-size-13 p-0'>
                                  {formatMessage({ id: 'Please wait...' })}
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              ) : (
                                <span className='indicator-label font-size-13 p-0'>
                                  {formatMessage({ id: 'Submit' })}
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
    </>
  )
}

export default CreateNewScenario
